import React, { createContext, useContext, useState } from "react";

const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
  const [colors, setColors] = useState({
    introduction: {},
    stream: {},
    products: {},
    articles: {},
  });

  const updateColors = (section, newColors) => {
    setColors(prevColors => ({
      ...prevColors,
      [section]: newColors,
    }));
  };

  return (
    <ColorContext.Provider value={{ colors, updateColors }}>
      {children}
    </ColorContext.Provider>
  );
};

export const useColors = () => useContext(ColorContext);
